// extracted by mini-css-extract-plugin
export default {"wrapper":"Legend__wrapper--RPhtM","options":"Legend__options--pXcxf","option":"Legend__option--YJ3_D","icon":"Legend__icon--zgpe7"};